import script from "./PaymentMethods.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentMethods.vue?vue&type=style&index=0&id=43dd97a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43dd97a0"]])

export default __exports__